import { isFeature } from 'Cloud/Application/FeaturesEs6';

export const aiFeatureIconBenefitsTable = isFeature('ai-feature-icon-benefits-table');
